/* Lines the card price up with the % on the same line (Price & Quick Add >
   "Line up price with % automatically").
   Performance: reads every position in one go (no DOM changes while
   measuring, so the browser lays the page out once), then writes once.
   Runs when the browser is idle and only watches the product grids.
   Note: never put attributes on <product-recommendations>. The theme reloads its
   cards whenever an attribute changes, which cancelled the first load and hid the strip. */
(() => {
  if (window.pbwPriceAlign) return;
  window.pbwPriceAlign = true;

  const SEL = '.ja-quick-add-container[data-pbw-autolift]';
  const desktop = window.matchMedia('(min-width: 750px)');
  const DESCENT = 0.206; // share of the text box below the baseline (Montserrat)

  function baselineOf(el) {
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, {
      acceptNode: (n) => (n.textContent.trim() ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP),
    });
    const text = walker.nextNode();
    if (!text) return null;
    const range = document.createRange();
    range.selectNodeContents(text);
    const r = range.getBoundingClientRect();
    if (!r.height) return null;
    return r.bottom - r.height * DESCENT;
  }

  // Card pictures open on the bottle shot: if Safari left a card's picture
  // slideshow on the second (hover) image while loading, put it back.
  function resetCardPictures() {
    document.querySelectorAll('.card-gallery slideshow-component[disabled] slideshow-slides').forEach((s) => {
      if (s.scrollLeft > 1 && !s.closest('.card-gallery').matches(':hover')) s.scrollTo({ left: 0, behavior: 'instant' });
    });
  }

  function run() {
    resetCardPictures();
    const key = desktop.matches ? 'pbwAutoDesk' : 'pbwAutoMob';
    const moves = [];
    // Read phase only.
    document.querySelectorAll(SEL).forEach((qa) => {
      const price = qa.querySelector('.product-card__quick-add-price');
      if (!price) return;
      if (qa.dataset[key] !== '1') {
        if (price.style.marginTop) moves.push({ price, margin: null });
        return;
      }
      const card = qa.closest('.product-card__content');
      const abv = card && card.querySelector(
        ':scope > :nth-last-child(2) > .group-block-content > :last-child > .group-block-content > .text-block:last-child'
      );
      if (!abv) return;
      const p = baselineOf(price);
      const a = baselineOf(abv);
      if (p == null || a == null) return;
      const delta = p - a;
      if (Math.abs(delta) < 0.5) return;
      const current = parseFloat(getComputedStyle(price).marginTop) || 0;
      moves.push({ price, margin: current - delta });
    });
    // Write phase.
    moves.forEach(({ price, margin }) => {
      if (margin == null) price.style.removeProperty('margin-top');
      else price.style.setProperty('margin-top', `${margin.toFixed(1)}px`, 'important');
    });
  }

  let queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    const go = () => {
      queued = false;
      run();
    };
    if ('requestIdleCallback' in window) requestIdleCallback(go, { timeout: 1500 });
    else setTimeout(go, 200);
  }

  const watched = new WeakSet();
  function watch(root) {
    if (!root || watched.has(root)) return;
    watched.add(root);
    new MutationObserver(schedule).observe(root, { childList: true });
  }

  function start() {
    window.addEventListener('pageshow', (e) => { if (e.persisted) schedule(); });
    if (document.readyState !== 'complete') window.addEventListener('load', schedule, { once: true });
    if (!document.querySelector(SEL) && !document.querySelector('product-recommendations')) return;
    // One pass once the fonts are in (measuring before would need a second pass).
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
    else schedule();
    let w = window.innerWidth;
    window.addEventListener('resize', () => {
      if (window.innerWidth !== w) {
        w = window.innerWidth;
        schedule();
      }
    }, { passive: true });
    // Cards added later: Load more (product grid) and You may also like.
    document.querySelectorAll('ul.product-grid, product-recommendations').forEach(watch);
    document.addEventListener('shopify:section:load', schedule);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
